import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { ContestRubricFormSectionDeleteModalComponent } from './contest-rubric-form-section-delete-modal.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [ContestRubricFormSectionDeleteModalComponent],
  exports: [ContestRubricFormSectionDeleteModalComponent],
})
export class ContestRubricFormSectionDeleteModalModule {}
